<div class="modal-background">
    <div class="modal-background">
        <div class="modal-content spinner">
            <div class="spinner-container">
                <p>Loading...</p>
                <p-progressSpinner></p-progressSpinner>
            </div>
        </div>
    </div>    
</div>